module.exports = __webpack_public_path__ + "img/standardSDZXL.046b1cd5.png";